import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement('path', { d: 'M29.65 9.56A2.65 2.65 0 0 0 27 6.91H5a2.65 2.65 0 0 0-2.65 2.65v13a2.67 2.67 0 0 0 .77 1.86.64.64 0 0 0 .58.42 2.64 2.64 0 0 0 1.3.36h22a2.64 2.64 0 0 0 1.3-.36.64.64 0 0 0 .58-.42 2.67 2.67 0 0 0 .77-1.86zm-26 13v-13a1.35 1.35 0 0 1 .17-.63l8.78 7.19-8.73 7.14a1.32 1.32 0 0 1-.22-.7zM18.37 17l8.07 6.6H5.56l8.07-6.6 2 1.61a.64.64 0 0 0 .82 0zm1-.84l8.78-7.19a1.35 1.35 0 0 1 .17.63v13a1.32 1.32 0 0 1-.22.7zM27 8.21l-11 9-11-9h22z' })
));